import type { en } from "./en";

export type Locale = "sv" | "en";

export const DEFAULT_LOCALE: Locale = "sv";
export const LOCALE_COOKIE = "locale";

export type Dictionary = typeof en;

export function normalizeLocale(value: string | undefined | null): Locale {
  return value === "en" || value === "sv" ? value : DEFAULT_LOCALE;
}

type TranslateVars = Record<string, string | number>;

export type TranslateOptions = TranslateVars & {
  defaultValue?: string;
  count?: number;
};

function resolvePath(dict: Dictionary, key: string): unknown {
  return key
    .split(".")
    .reduce<unknown>(
      (node, part) =>
        node && typeof node === "object" ? (node as Record<string, unknown>)[part] : undefined,
      dict,
    );
}

function interpolate(value: string, vars?: TranslateVars): string {
  if (!vars) return value;
  return value
    .replace(/\{\{(\w+)\}\}/g, (match, name: string) => (name in vars ? String(vars[name]) : match))
    .replace(/\{(\w+)\}/g, (match, name: string) => (name in vars ? String(vars[name]) : match));
}

export function translateObject(dict: Dictionary, key: string, defaultValue?: unknown): unknown {
  const value = resolvePath(dict, key);
  if (value === undefined) return defaultValue !== undefined ? defaultValue : key;
  return value;
}

export function translate(dict: Dictionary, key: string, vars?: TranslateOptions): string {
  let value: unknown;
  if (vars && typeof vars.count === "number") {
    const suffix = vars.count === 1 ? "_one" : "_other";
    value = resolvePath(dict, `${key}${suffix}`);
  }
  if (typeof value !== "string") value = resolvePath(dict, key);

  if (typeof value !== "string") {
    if (vars && typeof vars.defaultValue === "string") {
      return interpolate(vars.defaultValue, vars);
    }
    return key;
  }
  return interpolate(value, vars);
}
